(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/payment/common/assets/javascripts/error/request-racing-payment-error.js') >= 0) return;  svs.modules.push('/components/payment/common/assets/javascripts/error/request-racing-payment-error.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
const _svs$components$payme = svs.components.payment.common.error.constants,
  ClientErrorMessages = _svs$components$payme.ClientErrorMessages,
  ClientErrorCodes = _svs$components$payme.ClientErrorCodes,
  ErrorFacillities = _svs$components$payme.ErrorFacillities;
const getErrorCodeValue = svs.components.payment.common.error.utils.getErrorCodeValue;
const PaymentError = svs.components.payment.common.error.PaymentError;
const ErrorFacillityCodesRacing = Object.freeze({
  [ErrorFacillities.GATEWAY]: {
    112: ClientErrorCodes.PAYMENT_REQUEST_FAILURE_RACING
  },
  [ErrorFacillities.GAME]: {
    103: ClientErrorCodes.BAD_DRAW_RACING_CANCELLED_PARTICIPANT,
    105: ClientErrorCodes.BAD_DRAW_RACING_RACE_STARTED,
    107: ClientErrorCodes.BAD_DRAW_RACING_RACE_NOT_OPENED,
    124: ClientErrorCodes.BAD_DRAW_RACING_REG_BET_DISABLED
  }
});

class RequestRacingPaymentError extends PaymentError {
  constructor(_ref) {
    var _ErrorFacillityCodesR, _ClientErrorMessages$;
    let _ref$clientCode = _ref.clientCode,
      clientCode = _ref$clientCode === void 0 ? ClientErrorCodes.GENERIC_ERROR : _ref$clientCode,
      code = _ref.code,
      extraData = _ref.extraData;
    const _getErrorCodeValue = getErrorCodeValue(code),
      _getErrorCodeValue2 = _slicedToArray(_getErrorCodeValue, 2),
      facillity = _getErrorCodeValue2[0],
      errorCode = _getErrorCodeValue2[1];
    const racingError = ErrorFacillityCodesRacing === null || ErrorFacillityCodesRacing === void 0 || (_ErrorFacillityCodesR = ErrorFacillityCodesRacing[facillity]) === null || _ErrorFacillityCodesR === void 0 ? void 0 : _ErrorFacillityCodesR[errorCode];
    if (racingError) {
      clientCode = racingError;
    }
    const message = (_ClientErrorMessages$ = ClientErrorMessages[clientCode]) !== null && _ClientErrorMessages$ !== void 0 ? _ClientErrorMessages$ : "Generic error, errorCode: ".concat(code);
    super({
      clientCode,
      code,
      extraData,
      message
    });
    this.name = 'RequestRacingPaymentError';
  }
  get severity() {
    if (this.clientCode === ClientErrorCodes.BAD_BET) {
      return 'warn';
    }
    return super.severity;
  }
}
_defineProperty(RequestRacingPaymentError, "ClientErrorCodes", ClientErrorCodes);
setGlobal('svs.components.payment.common.error.RequestRacingPaymentError', RequestRacingPaymentError);

 })(window);